module.exports = __webpack_public_path__ + "img/adhibition-3.0148ff3.png";